import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ec7fb18")

_pushScopeId("data-v-8ec7fb18")
const _hoisted_1 = { class: "w-full pt-2 pb-4 px-4 h-full bg-gray-lp-1200" }
const _hoisted_2 = { class: "bg-white w-full h-full rounded-xl p-4" }
const _hoisted_3 = {
  key: 1,
  class: "cargo-table"
}
const _hoisted_4 = { class: "flex flex-col gap-1 text-gray-lp-300 text-sm" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_9 = { class: "hidden" }
const _hoisted_10 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CargoFilterSection = _resolveComponent("CargoFilterSection")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Print = _resolveComponent("Print")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_CargoFilterSection, {
          ref: "filterSection",
          onOnChangeFilter: _ctx.onHandleFilter
        }, null, 8, ["onOnChangeFilter"]),
        (_ctx.cargoListAvailable)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              customMessage: "Oops.. Belum ada data yang dapat ditampilkan"
            }))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_TableV2, {
                columns: !_ctx.isActionAble ? _ctx.columns : _ctx.columns.slice(0, -1),
                data: _ctx.cargoList,
                loading: _ctx.isLoading,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
                totalColumnFreeze: !_ctx.isActionAble ? 1 : 0,
                paginationStyle: "v3",
                isRightFreeze: "",
                onRequest: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchCargoList('retry'))),
                errorCause: _ctx.errorCause,
                isDetailAble: _ctx.ableToViewDetail,
                isTabList: false,
                onClick: _ctx.onClickRow,
                groupAction: true,
                groupOptions: _ctx.actionGroupOptions,
                isSpaceTop: false,
                bgHeader: "bg-white border-b border-gray-lp-200",
                paginationV3PaddingVertical: 'py-4',
                customClassPagination: 'absolute w-full bottom-4 right-0 left-0 -mb-4 px-8',
                pinnedSubstractHeight: "340px",
                isPinnedScrollBottom: "",
                isNoPaddingBottom: ""
              }, {
                origin_destination: _withId(({item}) => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _withDirectives(_createVNode("span", null, [
                        _createTextVNode(_toDisplayString(item.originCityCode), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          item.originCityName,
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _hoisted_6,
                      _withDirectives(_createVNode("span", null, [
                        _createTextVNode(_toDisplayString(item.destinationCityCode), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          item.destinationCityName,
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ]),
                    (item.cargoType === 'plane')
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _withDirectives(_createVNode("span", null, [
                            _createTextVNode(_toDisplayString(item.airportOriginCityCode), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              item.airportOriginCityName,
                              void 0,
                              { bottom: true }
                            ]
                          ]),
                          _hoisted_8,
                          _withDirectives(_createVNode("span", null, [
                            _createTextVNode(_toDisplayString(item.airportDestinationCityCode), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              item.airportDestinationCityName,
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["columns", "data", "loading", "pagination", "totalColumnFreeze", "errorCause", "isDetailAble", "onClick", "groupOptions"])
            ])),
        _withDirectives(_createVNode("div", _hoisted_9, null, 512), [
          [_directive_click_outside, () => (_ctx.chevronUp = _ctx.chevronUp.map(() => false))]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: () => _ctx.handlerModalCancelBooking(false),
          onClose: () => _ctx.cancelCargo(),
          title: "Apakah anda yakin ingin membatalkan?",
          message: "Jika memilih \"Ya\" sistem akan membatalkan proses booking",
          image: "badge-confirmation-general",
          textSuccess: "Tidak",
          textCancel: "Ya",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose"]), [
          [_vShow, _ctx.showModalCancelBooking]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
})